import React, { useState, useEffect, useRef } from 'react';
import TextTransition, { presets } from 'react-text-transition';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/services/api';
import { SERVICE } from '../utils/constants/services';
import 'animate.css';
import Swal from 'sweetalert2';
import useSignalRConnection from "../utils/signalr"
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { FaUserAlt } from 'react-icons/fa';
import { IoFingerPrint } from 'react-icons/io5';
import { IoIosFingerPrint, IoMdFingerPrint } from 'react-icons/io';
import { jwtDecode } from 'jwt-decode';

const TEXTS = ['Administración', 'Captura'];

export default function Login2(props) {
  const [credential, setCredential] = useState({
    username: '',
    password: '',
    system: "INVIRTIENDO PLUS"
  });
  const [connection, setConnection] = useState(null);

  const [index, setIndex] = useState(0);
  const [isLogin, setIsLogin] = useState(false);
  const [areaActual, setAreaActual] = useState("user");
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const { userId, setUserId, menuActual, setMenuActual, setEstados, setMunicipios, setCodigos, setDocumentTypes, codigos, municipios, estados, documentTypes, setReferenceTypes, token, setToken, permisos, setPermisos, userName, setUserName, setCommunications } = useAuth();
  const handleChange = (e) => {
    setCredential({
      ...credential,
      [e.target.name]: e.target.value
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    //setLoading(true);
  }
  const handleLogin = () => {
    setLoading(true);
    api(SERVICE.login + `?userName=${credential.username}&password=${credential.password}`)
      .then((data) => {
        if (data.data.data) {
          let user = data.data.data;
          let tokendecode = jwtDecode(user.token);
          localStorage.setItem("token", user.token);
          setToken(user.token);
          setUserId(tokendecode["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]);
          setUserName(credential.username);
          setPermisos(user.permissions);
          setName(credential.username);
          setIsLogin(true);
          handleGetMunicipio();
          handleGetPostalCode();
          handleGetState();
          handleGetDocumentType();
          handleGetReferenceType();
          handleGetCommunications();

        }
        else {
          Swal.fire({
            text: 'Credenciales incorrectas, intenta de nuevo.',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        }
      })
      .catch((err) => {
        Swal.fire({
          text: 'Credenciales incorrectas, intenta de nuevo.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      })
      .finally(() => {
        setLoading(false);
      })
  }
  const handleGetState = () => {
    api(SERVICE.getState)
      .then((data) => {
        let arrayTemp = [];
        if (data.data.data) {
          for (let index = 0; index < data.data.data.length; index++) {
            const element = data.data.data[index];
            arrayTemp.push({
              value: element.id,
              label: element.description
            });

          }
        }
        setEstados(arrayTemp);
      })
      .catch((err) => {
        console.log(err);
      })
  }
  const handleGetMunicipio = () => {
    api(SERVICE.getMunicipal)
      .then((data) => {
        let arrayTemp = [];
        if (data.data.data) {
          for (let index = 0; index < data.data.data.length; index++) {
            const element = data.data.data[index];
            arrayTemp.push({
              value: element.id,
              label: element.description,
              stateId: element.stateId
            });

          }
        }
        setMunicipios(arrayTemp);
      })
      .catch((err) => {
        console.log(err);
      })
  }
  const handleGetDocumentType = () => {
    api(SERVICE.getDocumentstypes)
      .then((data) => {
        let arrayTemp = [];
        if (data.data.data) {
          for (let index = 0; index < data.data.data.length; index++) {
            const element = data.data.data[index];
            arrayTemp.push(element);

          }
        }
        setDocumentTypes(arrayTemp);
      })
      .catch((err) => {
        console.log(err);
      })
  }
  const handleGetReferenceType = () => {
    api(SERVICE.getReferenceTypes)
      .then((data) => {
        let arrayTemp = [];
        if (data.data.data) {
          for (let index = 0; index < data.data.data.length; index++) {
            const element = data.data.data[index];
            arrayTemp.push(element);

          }
        }
        setReferenceTypes(arrayTemp);
      })
      .catch((err) => {
        console.log(err);
      })
  }
  const handleGetPostalCode = () => {
    api(SERVICE.getPostal)
      .then((data) => {
        let arrayTemp = [];
        if (data.data.data) {
          for (let index = 0; index < data.data.data.length; index++) {
            const element = data.data.data[index];
            arrayTemp.push({
              value: element.id,
              label: element.description + " - " + element.typeColony + ": " + element.nameColony,
              stateId: element.stateId,
              municipalityId: element.municipalityId
            });

          }
        }
        setCodigos(arrayTemp);
      })
      .catch((err) => {
        console.log(err);
      })
  }
  const handleGetCommunications = () => {
    api(SERVICE.getCommunications, {}, 'GET')
      .then((data) => {
        if (data.data.data) {
          setCommunications(data.data.data);
        } else {
          setCommunications([]);
        }
      })
      .catch((err) => {
        console.log('Error loading communications:', err);
        setCommunications([]);
      });
  }
  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000, // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  useEffect(() => {
    if (estados.length > 0 && municipios.length > 0 && codigos.length > 0) {
      setMenuActual("homeMenu");
    }
  }, [estados, municipios, codigos]);


  return (


    <div className="area2">
      <div class="colorElipseO1">

      </div>
      <div class="colorElipseO2">

      </div>
      <div className="login2 animate__animated animate__fadeInDown animate__slow">
        <div class="colorElipseI1">

        </div>
        <div class="colorElipseI2">

        </div>
        <div className='logoContainer'>
          <div className="logo">
            <img src='./assets/image/logo3.png'></img>
          </div>
          <div className="logo2" >
            <b style={{ marginRight: "10px", color: "#4293D7" }}>INVIRTIENDO </b> PLUS
          </div>

        </div>
        <div className='containerFormat' >
          <form onSubmit={handleSubmit} style={{ display: isLogin ? "none" : "", textAlign: "center" }}>
            <div className="logo3" >
              <b style={{ marginRight: "10px", color: "#4293D7" }}>LOGIN </b>
            </div>
            <div style={{ textAlign: "left" }}>
              <span>Ingresa tus datos para iniciar sesión</span>
              <br></br>
              <br></br>
              <div className="mb-3">
                <div >Usuario:</div>
                <input type="text" name="username" className="form-control" placeholder="Usuario *"
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <div>Contraseña :</div>
                <input type="password" name="password" className="form-control" placeholder="Contraseña *"
                  onChange={handleChange}
                />
              </div>

              <div className="d-grid gap-2">
                <button onClick={handleLogin} disabled={loading} className="btn btn-primary">
                  {
                    loading ?
                      (
                        <>
                          <div class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </>
                      )
                      :
                      (
                        <>
                          ENTRAR
                        </>
                      )
                  }

                </button>
              </div>
            </div>
          </form>
          <div className="animate__animated animate__fadeIn" style={{ width: "100%", display: isLogin ? "flex" : "none", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ fontSize: "25px", marginTop: "0px", color: "gray" }}>Bienvenido</div>
            <div style={{ fontSize: "45px", marginTop: "0px", marginBottom: "20px",color:"#4293D7" }}>{name}</div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={{ marginRight: "10px" }}>Cargando servicios...</div>
              <div class="spinner-border spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

          </div>
        </div>



      </div>


    </div>
  )
}
